<template>
  <div class="elese-nav">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item class="model">活动</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: pageNav.path }">{{pageNav.firstName}}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="pageNav.thirdName" :to="{ path:'/HCMegagameGetAwardProject' }">
          {{pageNav.thirdName}}
        </el-breadcrumb-item>
        <el-breadcrumb-item class="current-page">{{pageNav.secondName}}</el-breadcrumb-item>
      </el-breadcrumb>
  </div>
</template>

<script>
export default {
  props: { pageNav: Object },
  components: {},
  data () {
    return {}
  },
  computed: {},
  created () {},
  mounted () {},
  methods: {}
}
</script>

<style scoped lang="less">
.elese-nav{
    padding: 24px 0 0 17px;
}
.model{
    /deep/.el-breadcrumb__inner{
        color: #999 !important;
        text-decoration: none;
    }
}
/deep/.el-breadcrumb__inner {
  font-size: 16px;
  color: #000;
  text-decoration: underline;
}
/deep/.is-link {
  font-size: 16px;
  font-weight: 500;
}
.current-page{
   /deep/.el-breadcrumb__inner{
        color: #3c60db !important;
        text-decoration: none;
    }
}
</style>
